import 'jquery-parallax.js/parallax'
